import PropTypes from "prop-types";
import {capitaliseFirst, you} from "./__strings";

export default function assets(props) {
    const betterProps = {...props, ...{you: you(props.applicant === 1 ? false : props.mortgage.applicant2?.firstName ? props.mortgage.applicant2.firstName:'the other applicant')}}
    return {
        name: `assets-${props.applicant}`,
        title: "Savings & investments",
        link: `apply-${props.applicant}/assets`,
        defaultLabel: "Saving/investment",
        dynamicLabel: "institution",
        personalisedTitle: capitaliseFirst(betterProps.you.your) + ' savings & investments details',
        props: props,
        questions: [
            assetType(betterProps),
            institution(betterProps),
            // description(props),
            balance(betterProps),
            increasesFrequency(betterProps),
            increases(betterProps)
        ]
    }
}
export function assetType(props) {
    return {
        text: "What type of asset is this?",
        label: "Asset Type",
        name: "assetType",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "Investment",
                    value: "INVESTMENT"
                },
                {
                    text: "On Deposit",
                    value: "SAVING"
                }
            ]
        },
        model: "assets"
    }
}
export function institution(props) {
    return {
        name: "institution",
        answer: {
            type: "text",
        },
        text: {
            assetType: {
                INVESTMENT: "At what bank/institution is this investment held?",
                SAVING: "At what bank/institution are these savings held?"
            }
        },
        subtext: "eg. Bank of Ireland, AIB",
        label: "Institution",
        model: "assets"
    }
}
export function description(props) {
    return {
        name: "description",
        answer: {
            type: "text",
        },
        text: "Description of the investment",
        subtext: "eg. Shares, Art",
        label: "Description",
        model: "assets"
    }
}
export function balance(props) {
    return {
        name: "balance",
        answer: {
            type: "euro",
            validation:{
                min:{
                    value:100,
                    message:'The minimum value here is €100'
                },
                max:{
                    value:2000000,
                    message: 'You probably don\'t need a mortgage'
                }
            }
        },
        label: "Balance",
        text: {
            assetType: {
                INVESTMENT: "What is current value of this investment?",
                SAVING: "What is the balance in the account?"
            }
        },
        model: "assets"
    }
}
export function increasesFrequency(props) {
    return {
        text: "How often "+ props.you.doYou +" add funds to these savings",
        label: "Increases Frequency",
        name: "increasesFrequency",
        answer: {
            type: "choice",
            choices: [
                {
                    text: "yearly",
                    value: "YEARLY"
                },
                {
                    text: "quarterly",
                    value: "QUARTERLY"
                },
                {
                    text: "monthly",
                    value: "MONTHLY"
                },
                {
                    text: "fortnightly",
                    value: "FORTNIGHTLY"
                },
                {
                    text: "weekly",
                    value: "WEEKLY"
                },
                {
                    text: "occasionally",
                    value: "OCCASIONALLY"
                },
                {
                    text: "hardly ever",
                    value: "STATIC"
                }
            ]
        },
        hides: {
            assetType: (v) => {
                return v !== "SAVING"
            }
        },
        model: "assets"
    }
}
export function increases(props) {
    return {
        text: {
            increasesFrequency: {
                YEARLY: "By how much does this increase yearly?",
                QUARTERLY: "By how much this increase quarterly?",
                FORTNIGHTLY: "By how much this increase fortnightly?",
                MONTHLY: "By how much this increase monthly?",
                WEEKLY: "By how much this increase weekly?",
                OCCASIONALLY:"How much would you typically deposit?",
                STATIC: "How much would you typically deposit?",
            }
        },
        label: "Increases",
        name: "increases",
        answer: {
            type: "euro",
            validation: {
                min: {value: 1, message: "This must be a value greater than €1"},
                max: {value: 20000000, message: "You probably don't need a mortgage"}
            }
        },
        hides: {
            assetType: (v) => {
                return v === "INVESTMENT"
            },
            increasesFrequency: (v) => {
                return v === "STATIC"
            }
        },
        model: "assets"
    }
}
assets.propTypes = {
    applicant: PropTypes.number
}
